export class LoadFinOpsAzureResourcesHistoricalData {
    static type = '[FINOPS][AZURE][RESOURCES] LoadFinOpsAzureResourcesHistoricalData'
}

export class LoadDataTableAllSubscriptionsFinOpsAzureResources {
    static type = '[FINOPS][AZURE][RESOURCES] LoadDataTableAllSubscriptionsFinOpsAzureResources'
}

export class ClearFinOpsAzureResource {
    static type = '[FINOPS][AZURE][RESOURCES] ClearFinOpsAzureResource'
    constructor() { }
}

export class SetFinOpsAzureResource {
    static type = '[FINOPS][AZURE][RESOURCES] SetFinOpsAzureResource'
    constructor(public subscriptionId: string | undefined, public resourceId: string, public selectedDate?: Date) { }
}

export class LoadFinOpsAzureResourcesChartsData {
    static type = '[FINOPS][AZURE][RESOURCES] LoadFinOpsAzureResourcesChartsData'
}

export class LoadFinOpsAzureResourcesAllSubscriptionsChartsFilteredData {
    static type = '[FINOPS][AZURE][RESOURCES] LoadFinOpsAzureResourcesAllSubscriptionsChartsFilteredData'
}
